import { useEffect } from 'react';

export const useChatbotViewport = (
  scrollDivRef: React.RefObject<HTMLDivElement>,
  textareaHeight: number,
) => {
  useEffect(() => {
    const resizeHandler = () => {
      if (window.visualViewport && scrollDivRef.current) {
        scrollDivRef.current.style.height = `${
          window.visualViewport.height - textareaHeight - 22
        }px`;
        window.visualViewport.onscroll = () => window.scrollTo(0, 0);
      }
    };
    window.visualViewport?.addEventListener('resize', resizeHandler);
    return () => {
      window.visualViewport?.removeEventListener('resize', resizeHandler);
    };
  }, [scrollDivRef, textareaHeight]);
};
